module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rankBg"
  }, [_c('ul', {
    staticClass: "rank_list"
  }, _vm._l((_vm.plistList), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.toPlistPage(index)
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.plistName) + "\n\t\t\t\t\t"), _c('p', {
      staticClass: "plistNum"
    }, [_vm._v(_vm._s(item.plistNum))])]), _vm._v(" "), _vm._m(0, true)])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/arrow_icon.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8dccd5e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/plist.vue
// module id = 106
// module chunks = 0